











































































import { isObject, dateFormat } from "@szgc/plt-core-v2";
import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "DatetimePickerWidget",
  components: { MagicValidator }
})
export default class DatetimePickerWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent
{
  get dateTextStr() {
    if (this.value) {
      const dateVal = dateFormat(this.value, "YYYY年MM月DD日");
      return dateVal;
    }
    return "";
  }

  get dateText() {
    if (this.value) {
      const dateVal = dateFormat(this.value, this.widget.widgetFormat || "YYYY-MM-DD");
      return dateVal;
    }
    return "";
  }
  setValue(value: string) {
    this.value = value;
  }

  mounted() {
    if (this.status === "mine") {
      this.value =
        this.widget.ext === null || !this.widget.value
          ? isObject(this.defaultValue)
            ? this.defaultValue.value
            : this.defaultValue
          : this.widget.value;
    }
  }
}
